"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _searchPlaceTypes = require("./searchPlaceTypes");

var _CITY$COUNTY$NEIGHBOR;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = (_CITY$COUNTY$NEIGHBOR = {}, _defineProperty(_CITY$COUNTY$NEIGHBOR, _searchPlaceTypes.CITY, 10460), _defineProperty(_CITY$COUNTY$NEIGHBOR, _searchPlaceTypes.COUNTY, 32186), _defineProperty(_CITY$COUNTY$NEIGHBOR, _searchPlaceTypes.NEIGHBORHOOD, 1207), _defineProperty(_CITY$COUNTY$NEIGHBOR, _searchPlaceTypes.TOWN, 3218), _CITY$COUNTY$NEIGHBOR);

exports["default"] = _default;